import PropTypes from 'prop-types'
import React from 'react'

function MetaPill ({ label, value }) {
  return (
    <span className='flex items-center gap-sm font-size-xs text-neutral-500'>
      <span>{label}</span>
      <span
        className='font-mono radius-sm px-2'
        style={{
          backgroundColor: 'var(--color-neutral-100)',
          color: 'var(--text-color-main)',
          padding: '1px 6px',
          maxWidth: '220px',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap'
        }}
        title={value}
      >
        {value}
      </span>
    </span>
  )
}

MetaPill.propTypes = {
  label: PropTypes.string,
  value: PropTypes.string
}

export default MetaPill
